import { Range } from 'slate';
import { getCursorPositionInNode } from "./getCursorPositionInNode.js";
import { getListItemsInRange } from "./getListItemsInRange.js";
/**
 * Returns true when editor has collapsed selection and the cursor is at the beginning of a "list-item".
 */

export function isCursorAtStartOfListItem(editor) {
  if (!editor.selection || Range.isExpanded(editor.selection)) {
    return false;
  }

  var listItemsInSelection = getListItemsInRange(editor, editor.selection);

  if (listItemsInSelection.length !== 1) {
    return false;
  }

  var [[, listItemPath]] = listItemsInSelection;
  var {
    isStart
  } = getCursorPositionInNode(editor, editor.selection.anchor, listItemPath);
  return isStart;
}